// src/components/LoadingSpinner.jsx

import React from "react";
import "../App.css";

function LoadingSpinner() {
  return (
    <div className="loading-spinner" role="status" aria-live="polite">
      <div className="spinner" aria-hidden="true"></div>
      <p>Loading content, please wait...</p>
    </div>
  );
}

export default LoadingSpinner;
